import type { ModalProps } from "react-bootstrap";
import TeacherEvaluationUploadModal from "./TeacherEvaluationUploadModal";
import TeacherEvaluationQrCodeModal from "./TeacherEvaluationQrCodeModal";

interface Props {
  className?: string;
  onHide: () => void;
  onSubmit: () => void;
  show: boolean;
  size?: ModalProps["size"];
  userAssignmentId: string;
  variant?: "mobile" | "desktop";
}

const TeacherEvaluationModal: React.FC<Props> = ({ variant = "desktop", ...restProps }) => {
  if (variant === "mobile") {
    return <TeacherEvaluationUploadModal {...restProps} />;
  }

  return <TeacherEvaluationQrCodeModal {...restProps} />;
};

export default TeacherEvaluationModal;
